<button class="btn btn-link" (click)="onToggle()">
  <i class="bi {{ filterButtonProps.icon }}"></i> {{ filterButtonProps.label }}
</button>
